import {useNavigate} from 'react-router-dom'
import {DynamicColumnTable} from '@/components/organisms'
import {getCellDataMappedCols} from '@/helpers/dataTableCellDataMapper'
import {LinkText} from '@/components/atoms'

export const SubItemDataTable = ({subItemAccordionData}) => {
  const navigate = useNavigate()
  const subItemCellDataMapperObj = {
    productName: ({row: {original} = {}}) => {
      return (
        <div className="">
          <LinkText
            text={original?.productName}
            id={original?.productName + ' ' + original?.id}
            handleClick={() => navigate('/product-detail')}
          />
        </div>
      )
    },
  }

  const {subItemList = [], subItemColConfigData = []} = subItemAccordionData || {}
  const cellDataMappedCols = getCellDataMappedCols(subItemCellDataMapperObj, subItemColConfigData)

  return (
    <div>
      {subItemColConfigData?.length > 0 && subItemList?.length > 0 && (
        <DynamicColumnTable columns={cellDataMappedCols || []} records={subItemList || []} selection="single" />
      )}
    </div>
  )
}
